// @flow
import React from 'react';

import styles from './styles.module.scss';

interface LegendP {
  text: string,
  className: string,
}

const Legend = ({ text, className }: LegendP) => (
  <div className={styles.legend}>
    <div className={className} />
    <div>{text}</div>
  </div>
);

export default Legend;
